module.exports = __webpack_public_path__ + "static/VideoConferenceTool-49eaee00cede0c77228b813b179fc64e.png";